import type { Theme } from '@mui/material/styles';

export const getMuiOutlinedInput = (theme: Theme): Record<string, unknown> => ({
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.grey[400],
        },
      },
    },
  },
});
